<script setup lang="ts">
import { ListFilter } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export type InboxChannelOption = {
    id: 'all' | 'app' | 'email' | 'whatsapp' | 'form';
    label: string;
    count: number;
};

const props = withDefaults(defineProps<{
    modelValue?: InboxChannelOption['id'];
    options: InboxChannelOption[];
    label?: string;
}>(), {
    modelValue: 'all',
    label: 'Filter messages',
});

const emit = defineEmits<{
    'update:modelValue': [value: InboxChannelOption['id']];
}>();

const selectedOption = computed(() => props.options.find(option => option.id === props.modelValue) || props.options[0]);
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button type="button" variant="ghost" size="sm" class="h-9 gap-2 rounded-full px-2.5" :aria-label="label">
                <ListFilter class="size-4" />
                <span class="hidden text-xs sm:inline">{{ selectedOption?.label || 'All messages' }}</span>
                <span class="text-[10px] text-muted-foreground">{{ selectedOption?.count || 0 }}</span>
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="top" align="start" :side-offset="8" class="min-w-48">
            <DropdownMenuLabel>{{ label }}</DropdownMenuLabel>
            <DropdownMenuRadioGroup
                :model-value="modelValue"
                @update:model-value="emit('update:modelValue', $event as InboxChannelOption['id'])"
            >
                <DropdownMenuRadioItem v-for="option in options" :key="option.id" :value="option.id">
                    <span>{{ option.label }}</span>
                    <span class="ml-auto text-xs text-muted-foreground">{{ option.count }}</span>
                </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
